import React from 'react';
import {observer} from 'mobx-react';
import {DatePicker} from 'components';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import _ from 'lodash';

const DateField = observer(({field, viewModel}) => {
  const {uiState} = viewModel;

  if (uiState.massUpdate.readOnly && !viewModel.fields.get(field).has('newValue')) {
    return (
      <div className='waterloo'>
        <FormattedMessage id='mass_updates.edit.Not Changed'/>
      </div>
    );
  }

  return (
    <div>
      <DatePicker
        value={moment(viewModel.get(field).get('value'))}
        onChange={date => viewModel.set(field, date)}
        disabled={viewModel.disabled}
      />
      <div className='jumbo mt1'>
        <FormattedMessage
          id={viewModel.disabled ? 'mass_updates.edit.PREVIOUS_VALUE' : 'mass_updates.edit.CURRENT_VALUE'}
          values={{
            value: viewModel.get(field).get('oldValue') || '--'
          }}
        />
      </div>
    </div>
  );
});

export default DateField;
